var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5051 2.09047L11.0479 4.72561C11.1861 5.41154 10.7469 6.08266 10.061 6.22083C9.37507 6.359 8.70395 5.91981 8.56578 5.23389L8.02296 2.59874C7.88478 1.91282 8.32397 1.2417 9.0099 1.10352C9.69583 0.965351 10.367 1.40454 10.5051 2.09047Z",
    fill: "#39517D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6285 1.90283L7.84035 2.47526C7.32714 2.57888 6.8238 2.24826 6.72017 1.73505C6.61654 1.22184 6.94717 0.718493 7.46038 0.614864L10.2534 0.0424361C10.7666 -0.0611931 11.27 0.269433 11.3736 0.782645C11.4772 1.29586 11.1466 1.7992 10.6285 1.90283Z",
    fill: "#436094"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4961 13.8503C19.4961 17.9856 16.1306 21.3461 12.0002 21.3461C7.86988 21.3461 4.50439 17.9807 4.50439 13.8503C4.50439 9.72486 7.86988 6.35938 12.0002 6.35938C16.1306 6.35938 19.4961 9.72486 19.4961 13.8503Z",
    fill: "#FFFDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 3.71875C6.40914 3.71875 1.86426 8.26857 1.86426 13.8497C1.86426 19.4408 6.41407 23.9857 12.0002 23.9857C17.5863 23.9857 22.1361 19.4358 22.1361 13.8497C22.1361 8.26857 17.5912 3.71875 12.0002 3.71875ZM12.0002 21.3456C7.86488 21.3456 4.50434 17.9801 4.50434 13.8497C4.50434 9.72431 7.86982 6.35883 12.0002 6.35883C16.1305 6.35883 19.496 9.72431 19.496 13.8497C19.496 17.985 16.1355 21.3456 12.0002 21.3456Z",
    fill: "#436094"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3373 12.8574H16.4154C16.917 12.8574 17.3201 13.2652 17.3201 13.7621C17.3201 14.2637 16.9123 14.6668 16.4154 14.6668H12.3373C11.8357 14.6668 11.4326 14.259 11.4326 13.7621C11.4326 13.2652 11.8404 12.8574 12.3373 12.8574Z",
    fill: "#39517D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0421 15.5812C12.9792 15.5812 13.739 14.7691 13.739 13.7672C13.739 12.7653 12.9792 11.9531 12.0421 11.9531C11.1049 11.9531 10.3452 12.7653 10.3452 13.7672C10.3452 14.7691 11.1049 15.5812 12.0421 15.5812Z",
    fill: "#C4D4F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.3acaf872d7627b1a5ffcb008590cfa24.svg";
export { ForwardRef as ReactComponent };